import { createContext, useContext } from 'react';

const GigListingsContext = createContext();

export const GigListingsContextProvider = GigListingsContext.Provider;
export const useGigListingsContext = () => useContext(GigListingsContext);

export default GigListingsContext;
